"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservesContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ReservesContainer = styled_components_1.default.div `
  @media (min-width: 993px) {
    margin-left: calc(20px + (70 - 20) * ((100vw - 500px) / (1920 - 500)));
  }
`;
